import axios from 'axios';
import { API_URL } from '../constants';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

export function getPaymentCalendar(params) {
  return axios({ method: 'get', url: `${API_URL}/admin/payment_calendar`, params: params || {} });
}
